var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-upload-field',{attrs:{"field":_vm.field,"name":_vm.name,"value":_vm.field.value,"resource-slug":_vm.resourceSlug,"in-active-tab":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }